import { Injectable, Inject } from '@angular/core';
import { Resolve } from '@angular/router';

import { AlertTriggerService } from '../service';
import { AlertTriggers } from '../model';
import * as _ from 'underscore';

@Injectable({
  providedIn: 'root'
})
export class GetAlertTriggersResolver implements Resolve<AlertTriggers[]> {

  constructor(private alertTriggerService: AlertTriggerService) { }
  async resolve(): Promise<AlertTriggers[]> {
    let alert = await this.alertTriggerService.getAlertTriggers().toPromise();

    for (let i = 0; i < alert.length; i++) {
      if (alert[i].email_address != null) {
        let eArr = [...alert[i].email_address];
        let eString = eArr.join('');
        alert[i].email_address = new Array;
        alert[i].email_address = _.toArray(eString.split(';'));
      }
    };

    return alert;
  }

}
